export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-background-50 rounded-2xl border border-background-200 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
                随时随地，畅享漫画
              </h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                妖精漫画网全面适配移动端浏览器，无需下载安装即可在手机上获得流畅的下拉式阅读体验。添加到主屏幕，像原生App一样便捷访问海量免费漫画。
              </p>
              <div className="flex items-center justify-center lg:justify-start gap-3 flex-wrap">
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-950 text-background-50 text-sm font-medium">
                  <i className="ri-android-line"></i> Android 浏览器
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-950 text-background-50 text-sm font-medium">
                  <i className="ri-apple-line"></i> iOS Safari
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-100 text-foreground-700 text-sm">
                  <i className="ri-computer-line"></i> 桌面端
                </div>
              </div>
            </div>
            <div className="w-full max-w-[260px]">
              <div className="relative bg-background-100 rounded-2xl p-3 border-2 border-background-200">
                <div className="aspect-[9/16] rounded-xl overflow-hidden bg-background-50 flex items-center justify-center">
                  <div className="text-center p-6">
                    <div className="w-14 h-14 mx-auto flex items-center justify-center bg-primary-500 rounded-2xl mb-4">
                      <i className="ri-book-open-line text-2xl text-background-50"></i>
                    </div>
                    <div className="text-xs font-heading text-foreground-800 mb-1">妖精漫画</div>
                    <div className="text-[10px] text-foreground-400">下拉式流畅阅读</div>
                    <div className="mt-4 space-y-2">
                      <div className="h-1.5 bg-background-200 rounded-full w-full"></div>
                      <div className="h-1.5 bg-background-200 rounded-full w-4/5"></div>
                      <div className="h-1.5 bg-background-200 rounded-full w-3/5"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}